import { mount } from "@vue/test-utils";
import MobileNumber from "@/components/core/composite/MobileNumber";

describe("MobileNumber", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(MobileNumber, {
      propsData: {
        label: "Numero",
        name: "MobileNumber",
        value: {
          numero: ""
        }
      }
    });
  });

  it("Renders del component MobileNumber", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
